<template>
    <div
        v-if="maintenanceList && maintenanceList.length"
        class="maintenance-alert-wrapper"
    >
        <MaintenanceAlertItem
            v-for="item in maintenanceList"
            :key="item.id"
            :data="item"
        ></MaintenanceAlertItem>
    </div>
</template>

<script>
import MaintenanceAlertItem from '@/components/maintenance/MaintenanceAlertItem/MaintenanceAlertItem';
import { mapState } from 'vuex';

export default {
    name: 'MaintenanceAlert',
    components: {
        MaintenanceAlertItem,
    },
    computed: {
        ...mapState('maintenance', ['maintenanceList']),
    },
};
</script>
<style lang="scss" scoped>
@import 'MaintenanceAlert';
</style>
